import styled from '@mui/system/styled';

export const ReportingListCnt = styled('ul')({
  display: 'flex',
  flexDirection: 'column',
  padding: '0 30px',
  marginBottom: 30,
});
